import { apiService } from './api';
import { KotVoidReasonDTO, SaveKotVoidReasonDTO } from '../types';

const kotVoidReasonService = {
  getAll: () =>
    apiService.get<{ data: KotVoidReasonDTO[] }>('/kot-void-reasons'),

  create: (dto: SaveKotVoidReasonDTO) =>
    apiService.post<{ data: KotVoidReasonDTO }>('/kot-void-reasons', dto),

  update: (id: number, dto: SaveKotVoidReasonDTO) =>
    apiService.put<{ data: KotVoidReasonDTO }>(`/kot-void-reasons/${id}`, dto),

  delete: (id: number) =>
    apiService.delete(`/kot-void-reasons/${id}`),
};

export default kotVoidReasonService;
